import getModulesNames from "rapid/getModulesNames.helper";

import {detectDeviceDirective} from "./detect-device.directive";
import {keepWidthDirective} from "./keep-width.directive";
import {validateJsonDirective} from "./validator.directives";
import {confirmPassword} from "./confirm-password.directive";
import {dragMoveDirective} from "./drag-move.directive";
import {colorEyedropperDirective} from "./color-eyedropper.directive";
import {availableSizeDirective} from "./available-size.directive";

import {
    permissionShow,
    permissionHide, permissionReadonly
} from "./permissions.directive";


export const DirectivesModule = angular
    .module("app.directives", getModulesNames([]))
    .directive("detectDevice", detectDeviceDirective.create)
    .directive("keepWidth", keepWidthDirective.create)
    .directive("permissionShow", permissionShow.create)
    .directive("permissionHide", permissionHide.create)
    .directive("permissionReadonly", permissionReadonly.create)
    .directive("validateJson", validateJsonDirective.create)
    .directive("matchPassword", confirmPassword.create)
    .directive("dragMove", dragMoveDirective.create)
    .directive("colorEyedropper", colorEyedropperDirective.create)
    .directive("availableSize", availableSizeDirective.create);



// WEBPACK FOOTER //
// ./sources/directives/directives.module.js